import React from 'react';
import { useModalZIndex } from '../shared/modalStack';

interface OpenableProps {
    open?: boolean;
    style?: React.CSSProperties;
    [key: string]: unknown;
}

/**
 * Wraps a MUI Dialog (v4 or v5) and auto-assigns z-index from the global modal
 * stack. An explicit style.zIndex on the passed props takes precedence and the
 * modal still participates in the stack so subsequent modals open above it.
 */
export function createStackedDialog(DialogBase: React.ComponentType<any>): React.ComponentType<any> {
    const StackedDialog = ({ open = false, style, ...props }: OpenableProps) => {
        const stackedZIndex = useModalZIndex(open);
        const zIndex = style?.zIndex !== undefined ? style.zIndex : stackedZIndex;
        const mergedStyle = zIndex !== undefined ? { ...style, zIndex } : style;
        return <DialogBase open={open} style={mergedStyle} {...props} />;
    };
    const baseName = (DialogBase as any).displayName || (DialogBase as any).name || 'Dialog';
    StackedDialog.displayName = `Stacked(${baseName})`;
    return StackedDialog;
}
